const radius = {
  '--radius-xs': '6px',
  '--radius-s': '8px',
  '--radius-m': '12px',
  '--radius-l': '16px',
  '--radius-3xl': '40px',
  '--textarea-radius': '16px',
}

export default radius
